import * as yup from 'yup';

export const loginSchema = (confirmView: boolean) =>
    yup.object().shape({
        email: confirmView
            ? yup.string().notRequired()
            : yup
                  .string()
                  .trim()
                  .email('Please input a valid email address')
                  .required(),

        otp: confirmView
            ? yup
                  .string()
                  .trim()
                  .matches(/^\d{6}$/)
                  .required()
            : yup.string().notRequired(),
    });
